import { Component } from '@angular/core';

@Component({
  selector: 'app-logout-success',
  imports: [],
  templateUrl: './logout-success.component.html',
  styleUrl: './logout-success.component.scss',
})
export class LogoutSuccessComponent {}
